import script from "./SearchFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchFilter.vue?vue&type=script&setup=true&lang=ts"

import "./SearchFilter.vue?vue&type=style&index=0&id=f89166c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f89166c0"]])

export default __exports__